import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useGridFilterStore } from 'src/store/useGridFilters/useGridFilterStore';
import { goToZara } from 'src/utils/init/configuration';
import { getCategoryUrl, getURLFragmentId } from 'src/utils/seo-urls';
import useUniverseQuery from '../React_Query/Search/Universe/useUniverseQuery';
import { mainGridAnalyticMapper } from 'src/utils/analytics/page-views/main-grid/mappers/mainGridAnalyticMapper';
import setMetaTags from 'src/utils/seoTags';

export const getUrlIds = (url: string) => {
  const urlSegments = url.split('/');
  const productsPath = urlSegments.findIndex(segment => segment === 'products');

  if (urlSegments[productsPath + 2] !== undefined) {
    const universeId = getURLFragmentId(decodeURIComponent(urlSegments[productsPath + 1]))
    const gridId = getURLFragmentId(decodeURIComponent(urlSegments[productsPath + 2]))
    return { gridId: Number(gridId), universeId: Number(universeId) }

  } else {
    return undefined
  }
}

export default function useGridMainLogic() {

  const history = useHistory();
  const SET_FILTER = useGridFilterStore(state => state.SET_MAIN_FILTER)
  const SET_DEFAUlT_URL = useGridFilterStore(state => state.SET_DEFAUlT_URL)
  const gridFilters = useGridFilterStore(state => state.gridMainFilters)
  const { data: universeResponse, isSuccess: isUniverseResponseSuccess } = useUniverseQuery();



  const getDefaultGridAndUniverse = () => {
    const universe = universeResponse?.data?.content?.length > 0 && universeResponse?.data?.content[0];
    const grid = universe?.grids?.length > 0 && universe?.grids[0]

    if (!!universe && !!grid) {
      setMetaTags({pageType:"category", name:universe?.name , section: `${grid?.name}`})
      return { grid, universe }
    } else {
      return null
    }
  }

  const getDefaultGridURL = () => {
    if (getDefaultGridAndUniverse()) {
      const { grid, universe } = getDefaultGridAndUniverse()
      const defaultUrl = getCategoryUrl(universe, grid);
      SET_DEFAUlT_URL("defaultGridUrl", defaultUrl)
    } else {
      return null
    }
  }

  const setDefaultUniverseAndGrid = () => {
    if (getDefaultGridAndUniverse()) {
      const { grid, universe } = getDefaultGridAndUniverse()
      SET_FILTER("gridId", grid.id, { gridId: grid.id, universeId: universe.id })
      const targetUrl = getCategoryUrl(universe, grid);
      history.replace(targetUrl);
      setMetaTags({pageType:"category", name:universe?.name , section: `${grid?.name}`})
      mainGridAnalyticMapper(universeResponse, universe?.id,grid?.id )
    } else {
      goToZara()
    }
  }

  useEffect(() => { // solo lo va a ejecutarse cuando renderiza la pagina de productos por primera vez
    
    if (isUniverseResponseSuccess) {
      if (gridFilters.isInitialState) {
        getDefaultGridURL()
        if (getUrlIds(window.location.href)) { // se lanza cuando  hay ids en la URL
          const currenteUniverseDto = universeResponse?.data?.content.find((univ) => univ.id === getUrlIds(window.location.href).universeId);
          const currentGridDto = currenteUniverseDto?.grids?.find(g => g.id === getUrlIds(window.location.href).gridId)
 

          if (currenteUniverseDto && currentGridDto) { // se lanza cuando  hay ids en la URL y estos ids existen en la respuesta de universos
            const gridAndUniverseIds = getUrlIds(window.location.href)
            SET_FILTER("gridId", gridAndUniverseIds.gridId, gridAndUniverseIds)
            setMetaTags({pageType:"category", name:currenteUniverseDto?.name , section: `${currentGridDto?.name}`})
            mainGridAnalyticMapper(universeResponse, currenteUniverseDto?.id,currentGridDto?.id )
          }

          else { // se lanza cuando  hay ids en la URL y estos ids no existen en la respuesta de universos porque se modificaron manualmente la URL
            setDefaultUniverseAndGrid()
            
          }

        } else if (universeResponse?.data?.content?.length > 0) { // se lanza cuando no hay ids en la URL
          setDefaultUniverseAndGrid()
        }

        else {
          goToZara()
        }
      }

      else { // se lanza cuando volvemos a la grid principal desde otra página y ya tenemos filtros seteados
        if (gridFilters.gridId && gridFilters.universeId) {
          const currenteUniverseDto = universeResponse?.data?.content.find((univ) => univ.id === gridFilters.universeId);
          const currentGridDto = currenteUniverseDto?.grids?.find(g => g.id === gridFilters.gridId)
          if (!!currenteUniverseDto && !!currentGridDto) {
            const targetUrl = getCategoryUrl(currenteUniverseDto, currentGridDto);
            history.replace(targetUrl);
            setMetaTags({pageType:"category", name:currenteUniverseDto?.name , section: `${currentGridDto?.name}`})
            mainGridAnalyticMapper( universeResponse ,currenteUniverseDto?.id,currentGridDto?.id )
          } else {
            setDefaultUniverseAndGrid()
          }         
        }
      }
    }
  }, [isUniverseResponseSuccess])
}
